export const templateOptions = {
  Blank: 'Blank',
  SupportBot: 'Support Bot',
  SalesBot: 'Sales Bot'
}

export type Template = keyof typeof templateOptions
